import React, { useState , useEffect} from 'react';
import { getDatabase, ref, get, child , remove} from 'firebase/database';
import { app } from '../firbase';
import { useNavigate } from 'react-router-dom';
import '../styles/editbooking.css'
import sendEmail from './emailjs_script';

const EditBooking = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [bookings, setBookings] = useState(null);
  const [error, setError] = useState('');
  const [disabledStartTimes, setDisabledStartTimes] = useState([]);
const [disabledEndTimes, setDisabledEndTimes] = useState([]);

  const navigate = useNavigate();
  const db = getDatabase(app);
 


  const timeSlots = [
    '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM',
    '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM',
    '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM', '7:00 PM',
    '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM', '9:30 PM', '10:00 PM',
    '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM', '12:30 AM',
    '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM', '3:00 AM'
  ];

  const timeToValue = (time) => {
    if (!time) return 0;
    const [hour, minPart] = time.split(':');
    const minutes = parseInt(minPart.slice(0, 2), 10);
    const isPM = time.toLowerCase().includes('pm');
    let hr = parseInt(hour, 10);
    if (isPM && hr !== 12) hr += 12;
    if (!isPM && hr === 12) hr = 0;
    let total = hr * 60 + minutes;

    // If the time is after midnight (12:00 AM - 3:00 AM), treat it as next day by adding 24*60
    if (total <=180) {
      total += 1440;
    }
    return total;
    
  
  }




  const getFilteredTimeSlots = () => {
    if (!bookings?.date) return timeSlots;
  
    const selectedDate = new Date(bookings?.date);
    const now = new Date();
  
    // Clone and normalize both dates to midnight
    const selectedDay = new Date(selectedDate);
    const today = new Date(now);
  
    selectedDay.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
  
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();
  
    const currentTimeValue = timeToValue(
      `${currentHour % 12 || 12}:${currentMinutes.toString().padStart(2, '0')} ${currentHour >= 12 ? 'PM' : 'AM'}`
    );
  
    const isSameDay = selectedDay.getTime() === today.getTime();
    const isPreviousDay = selectedDay.getTime() === today.getTime() - 86400000; // 1 day in ms
    const isPastDay = selectedDay < today && !isPreviousDay;
  
    // Fully past day (e.g., trying to book 17th on 19th)
    if (isPastDay) return [];
  
    // Booking for previous day (early morning hours, 12am–3am)
    if (isPreviousDay && currentHour < 3) {
      return timeSlots.filter(slot => timeToValue(slot) > currentTimeValue);
    }
  
    // Booking for today (after 3am), show only future slots
    if (isSameDay) {
      return timeSlots.filter(slot => timeToValue(slot) > currentTimeValue);
    }
  
    // Booking for future day — show full slot list
    return timeSlots;
  };
  


  const handleSearch = async () => {
    const bookingId = `${phone}`;
    const dbRef = ref(db);
    try {
      const snapshot = await get(child(dbRef, `bookings/${bookingId}`));
      if (snapshot.exists()) {
         const data = snapshot.val();
        setBookings(data);
        setName(data.name);  // ✨ autofill correct name from DB
        setError('')
        // const data = snapshot.val();
        // if (data.name?.toLowerCase().trim() === name.toLowerCase().trim()) {
        //   setBookings(data);
        //   setError('');
        // } else {
        //   setError('Name does not match.');
        //   setBookings(null);
        // }
      } else {
        setError('No bookings found for this user.');
        setBookings(null);
      }
    } catch (err) {
      setError('Error fetching booking.');
      setBookings(null);
    }
  };


  const isPastDate = (date) => {
    const selected = new Date(date);
    const now = new Date();
  
    const isEarlyMorning = now.getHours() < 3;
    const effectiveToday = new Date();
    effectiveToday.setDate(effectiveToday.getDate() - (isEarlyMorning ? 1 : 0));
    effectiveToday.setHours(0, 0, 0, 0);
  
    selected.setHours(0, 0, 0, 0);
    return selected < effectiveToday;
  };
  
  
  const hasOverlap = () => {
    const { startTime, endTime } = bookings;
    const currentStart = timeToValue(startTime);
    const currentEnd = timeToValue(endTime);
  
    for (let i = 0; i < disabledStartTimes.length; i++) {
      const slotVal = timeToValue(disabledStartTimes[i]);
      if (slotVal >= currentStart && slotVal < currentEnd) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    // Add the class to body when the About page is rendered
    document.body.classList.add('edit-booking-page-body');
    
    // Clean up by removing the class when the component unmounts
    return () => {
      document.body.classList.remove('edit-booking-page-body');
    };
  }, []);

  useEffect(() => {
    if (bookings?.date && bookings?.table) {
      const bookingsRef = ref(db, 'bookings/');
      get(bookingsRef).then((snapshot) => {
        if (snapshot.exists()) {
          const all = snapshot.val();
          const filtered = Object.entries(all).filter(
            ([key, b]) =>
              b.date === bookings.date &&
              b.table === bookings.table &&
              key !== `${phone}`
          );

        
            // disable all booked time slots
            let startDisabled = new Set();
            let endDisabled = new Set();
          filtered.forEach(([_,b]) => {
            const start = timeToValue(b.startTime);
            const end = timeToValue(b.endTime);
            timeSlots.forEach((slot) => {
              const val = timeToValue(slot);
              if (val > start && val < end ) {
                startDisabled.add(slot); // for startTime
                endDisabled.add(slot);   // for endTime
              }
              if (val === end) {
                endDisabled.add(slot); // prevent choosing exact end time
              }
              if (val === start) {
                startDisabled.add(slot); // prevent choosing exact end time
              }
            });
          });
          setDisabledStartTimes(Array.from(startDisabled));
        setDisabledEndTimes(Array.from(endDisabled));
        } 
        
      });
    }// eslint-disable-next-line
  }, [bookings?.date, bookings?.table]);


  const handleCancel = () => {
    if (!name || !phone) {
        alert('Missing booking info!');
        return;
      }
  
      const bookingRef = ref(db, 'bookings/' + phone);
      remove(bookingRef)
        .then(() => {
          alert('Booking cancelled successfully!');
          sendEmail(bookings, 'CANCELLED BOOKING')
          navigate('/');
        })
        .catch((error) => {
          alert('Failed to cancel booking: ' + error.message);
        });
  };
  const getAdjustedTimeValue = (start, end) => {
    let startVal = timeToValue(start);
    let endVal = timeToValue(end);
  
    // If endVal is less than startVal, assume it's invalid duration
    if (endVal <= startVal) {
      return { isValid: false };
    }
  
    return {
      isValid: true,
      duration: endVal - startVal
    };
  };

  
  const handleUpdate = () => {
    const { name: n, phone: p, table, date, startTime, endTime,mode } = bookings;

  if (!n || !p || !table || !date || !startTime || !endTime || !mode) {
    alert('All fields are required!');
    return;
  }

  if (isPastDate(date)) {
    alert('Cannot book for past dates.');
    return;
  }

  if (timeToValue(startTime) >= timeToValue(endTime)) {
    alert('Start time must be earlier than end time.');
    return;
  }

  if (hasOverlap()) {
    alert('This slot is already booked for the selected table!');
    return;
  }

  if (timeToValue(endTime) - timeToValue(startTime) < 60) {
    alert('Minimum booking duration is 1 hour.');
    return;
  }

  const { isValid, duration } = getAdjustedTimeValue(startTime, endTime);

if (!isValid) {
  alert('Start time must be earlier than end time.');
  return;
}

if (duration < 60) {
  alert('Minimum booking duration is 1 hour.');
  return;
}

  sendEmail(bookings, 'UPDATED BOOKING');
    navigate('/updatedconfirmation', { state: { updatedBooking: { ...bookings }, bookingId: `${phone}` } });
  };

  return (
    <div className="edit-booking-page">
    <div className="edit-container">
      <h2 className="form-heading">
        EDIT BOOKING
      </h2>
  
      <input
        className="booking-input"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={bookings}
      />
  
      <input
        className="booking-input"
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        disabled={bookings}
      />
  
      <button className="booking-button-2" onClick={handleSearch}>
        Search Booking
      </button>
  
      {error && <p className="error-text">{error}</p>}
  
      {bookings && (
        <>
        <label className="booking-label2">Mode of booking</label>
<input
  className="booking-select2 input-update"
  value={bookings.mode}
  readOnly
/>
  
          <label className="booking-label2">Date</label>
          <input
            className="booking-select2 date-input input-update"
            type="date"
            value={bookings.date}
            onChange={(e) => setBookings({ ...bookings, date: e.target.value })}
          />

  
          <label className="booking-label2">Table</label>
          <select
            className="booking-select2"
            value={bookings.table}
            onChange={(e) => setBookings({ ...bookings, table: e.target.value })}
          >
             {[
    { value: 'S1', label: 'S1 => SteelCushion PRO Rs.300/hr' },
    { value: 'S2', label: 'S2 => MillenniumMs PRO Rs.250/hr' },
    { value: 'S3', label: 'S3 => SharmaS2 PRO Rs.240/hr' },
    { value: 'M1', label: 'M1 => 8-Ball/snooker 9/5ft Rs.200/hr' },
    { value: 'M2', label: 'M2 => 8-ball/snooker 10/5ft Rs.220/hr' },
    { value: 'PS4', label: 'PS4 => Rs.300/hr upto 4 ppl' },
    { value: 'PS5', label: 'PS5 => Rs.250/hr upto 2 ppl' },
    { value: 'PC', label: 'PC => Rs.150/hr' },
    // { value: 'M3', label: 'M3 => only 8-ball 6/4ft Rs.180/hr' },
  ].map((t) => (
    <option key={t.value} value={t.value}>
      {t.label}
    </option>
            ))}
          </select>
  
          <label className="booking-label2">Start Time</label>
          <select
            className="booking-select2"
            value={bookings.startTime}
            onChange={(e) => setBookings({ ...bookings, startTime: e.target.value })}
          >
            {getFilteredTimeSlots().map((slot) => (
              <option key={slot} value={slot} disabled={disabledStartTimes.includes(slot)}>
                {slot}
              </option>
            ))}
          </select>
  
          <label className="booking-label2">End Time</label>
          <select
            className="booking-select2"
            value={bookings.endTime}
            onChange={(e) => setBookings({ ...bookings, endTime: e.target.value })}
          >
            {getFilteredTimeSlots().map((slot) => (
              <option key={slot} value={slot} disabled={disabledEndTimes.includes(slot)}>
                {slot}
              </option>
            ))}
          </select>
  
          <button className="booking-button-2" onClick={handleUpdate}>
            Update Booking
          </button>
  
          <button className="booking-button-2 cancel" onClick={handleCancel}>
            Cancel Booking
          </button>
        </>
      )}
    </div>
    </div>
  );
  
};

export default EditBooking;
